import { captureException } from '@sentry/browser'
import enums from '@/utils/enum'
import Notification from '@/utils/notification/Notification'

export default class NetworkError extends Notification {
  constructor({
    msg = 'Oops an error occurred',
    severity = enums.notification.severity.WARNING,
    ex = false, // @type exception
    ...args
  } = {}) {
    super(args)
    this.msg = $t(msg)
    this.type = enums.notification.types.ERROR
    this.severity = severity
    if (ex) {
      captureException(ex)
    }
  }
}
